import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import DashboardLayout from "../../../components/layout/DashboardLayout";

import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";

import { useCustomerViewModel } from "../../../viewmodels/operation/customer/useCustomerViewModel";

import { useScaleModelViewModel } from "../../../viewmodels/operation/scale/useScaleModelViewModel";

import { useScaleViewModel } from "../../../viewmodels/operation/scale/useScaleViewModel";

const EditScale = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  const [selectedMake, setSelectedMake] = useState<any>(null);

  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);

  const [selectedAddress, setSelectedAddress] = useState<any>(null);

  const [selectedModel, setSelectedModel] = useState<any>(null);

  const [selectedCapacity, setSelectedCapacity] = useState<any>(null);

  const [manualCustomer, setManualCustomer] = useState(false);

  const [manualAddress, setManualAddress] = useState(false);

  const [manualMake, setManualMake] = useState(false);

  const [manualModel, setManualModel] = useState(false);

  const [manualCapacity, setManualCapacity] = useState(false);

  const [capacityValue, setCapacityValue] = useState("");

  const [capacityUnit, setCapacityUnit] = useState("kg");

  const [divisionValue, setDivisionValue] = useState("");

  const [divisionUnit, setDivisionUnit] = useState("kg");

  const [addressInput, setAddressInput] = useState("");

  const {
    createScale,

    updateScale,

    getScaleById,
  } = useScaleViewModel();

  const { loadMakeOptions, getModelsByMake, getCapacitiesByModel } =
    useScaleModelViewModel();

  const [models, setModels] = useState<any[]>([]);

  const [capacities, setCapacities] = useState<any[]>([]);

  const { loadCustomerOptions, loadAddressOptions } = useCustomerViewModel();

  const [form, setForm] = useState({
    serialNumber: "",

    isReserved: false,

    identifier: "",

    nmiNumber: "",

    location: "",

    comment: "",

    makeId: "",
    makeName: "",

    modelId: "",
    modelName: "",

    modelCapacityId: null,
    modelCapacity: null,

    customerId: "",
    customerName: "",

    addressId: "",
    addressLine1: "",

    customer: "",
    address: [] as string[],
    make: "",
    model: "",
    capacity: [] as string[],
    capacityText: "",
  });

  useEffect(() => {
    if (id) {
      loadScale();
    }
  }, [id]);

  const loadScale = async () => {
    const data = await getScaleById(id!);

    if (!data) return;

    setForm({
      ...data,

      customer: data.customer || "",

      address: data.address || [],

      make: data.make || "",

      model: data.model || "",

      capacity: data.capacity ? [data.capacity] : [],
    });

    // CUSTOMER

    if (data.customerId && data.customerName) {
      setSelectedCustomer({
        value: data.customerId,

        label: data.customerName,
      });
    }

    // ADDRESS

    if (data.addressId && data.addressLine1) {
      setSelectedAddress({
        value: data.addressId,

        label: data.addressLine1,

        data: {
          addressLine1: data.addressLine1,
        },
      });
    }

    // MAKE

    if (data.makeId && data.makeName) {
      setSelectedMake({
        value: data.makeId,

        label: data.makeName,
      });

      const modelsResult = await getModelsByMake(data.makeId);

      setModels(modelsResult || []);
    }

    // MODEL

    if (data.modelId && data.modelName) {
      setSelectedModel({
        value: data.modelId,

        label: data.modelName,
      });

      const capacitiesResult = await getCapacitiesByModel(data.modelId);

      setCapacities(capacitiesResult || []);
    }

    // CAPACITY

    if (data.modelCapacityId && data.modelCapacity) {
      setSelectedCapacity({
        value: data.modelCapacityId,

        label: `${data.modelCapacity.division}${data.modelCapacity.divisionUnitName} × ${data.modelCapacity.capacity}${data.modelCapacity.capacityUnitName}`,

        data: data.modelCapacity,
      });
    }
  };

  const submit = async (e: any) => {
    e.preventDefault();

    const toNullableGuid = (value: any) => {
      if (value === "" || value === undefined || value === null) {
        return null;
      }

      return value;
    };

    const payload = {
      serialNumber: form.serialNumber,

      isReserved: form.isReserved,

      identifier: form.identifier,

      nmiNumber: form.nmiNumber,

      location: form.location,

      comment: form.comment,

      // =========================
      // EXISTING OR NEW CUSTOMER
      // =========================

      customerId: manualCustomer ? null : toNullableGuid(form.customerId),

      customerName: manualCustomer ? null : form.customerName,

      customer: manualCustomer ? form.customer : null,

      // =========================
      // EXISTING OR NEW ADDRESS
      // =========================

      addressId: manualAddress ? null : toNullableGuid(form.addressId),

      addressLine1: manualAddress ? null : form.addressLine1,

      address: form.address || [],

      // =========================
      // EXISTING OR NEW MAKE
      // =========================

      makeId: manualMake ? null : toNullableGuid(form.makeId),

      makeName: manualMake ? null : form.makeName,

      make: manualMake ? form.make : null,

      // =========================
      // EXISTING OR NEW MODEL
      // =========================

      modelId: manualModel ? null : toNullableGuid(form.modelId),

      modelName: manualModel ? null : form.modelName,

      model: manualModel ? form.model : null,

      // =========================
      // EXISTING OR NEW CAPACITY
      // =========================

      modelCapacityId: manualCapacity
        ? null
        : toNullableGuid(form.modelCapacityId),

      modelCapacity: manualCapacity ? null : form.modelCapacity,

      capacity: manualCapacity ? form.capacity : [],
    };

    if (id) {
      await updateScale({
        id,

        ...payload,
      });
    } else {
      await createScale(payload);
    }

    navigate("/scales");
  };

  return (
    <DashboardLayout>
      <div className="p-4 md:p-6 max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">Edit Scale</h1>
        </div>

        <form onSubmit={submit} className="space-y-6">
          <div className="bg-white border border-slate-200 rounded-3xl p-6">
            <h2 className="text-xl font-bold mb-6">Scale Details</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5">
              {/* CUSTOMER */}

              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-medium">Customer</label>

                  <button
                    type="button"
                    onClick={() => {
                      setManualCustomer(!manualCustomer);

                      setSelectedCustomer(null);

                      setSelectedAddress(null);

                      setSelectedMake(null);

                      setSelectedModel(null);

                      setSelectedCapacity(null);

                      setModels([]);

                      setCapacities([]);

                      setForm((prev) => ({
                        ...prev,

                        customerId: "",
                        customerName: "",
                        customer: "",

                        addressId: "",
                        addressLine1: "",
                        address: [],

                        makeId: "",
                        makeName: "",
                        make: "",

                        modelId: "",
                        modelName: "",

                        modelCapacityId: null,
                        modelCapacity: null,
                      }));
                    }}
                    className="text-xs text-blue-600 hover:underline"
                  >
                    {manualCustomer ? "Select Existing" : "Add New"}
                  </button>
                </div>

                {manualCustomer ? (
                  <input
                    value={form.customer}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,

                        customer: e.target.value,
                      }))
                    }
                    placeholder="Enter Customer"
                    className="w-full border border-slate-300 rounded-xl px-4 py-3"
                  />
                ) : (
                  <AsyncPaginate
                    value={selectedCustomer}
                    loadOptions={loadCustomerOptions}
                    additional={{ page: 1 }}
                    placeholder="Search Customer"
                    onChange={(selected: any) => {
                      setSelectedCustomer(selected);

                      // RESET EVERYTHING BELOW CUSTOMER

                      setSelectedAddress(null);

                      setSelectedMake(null);

                      setSelectedModel(null);

                      setSelectedCapacity(null);

                      setModels([]);

                      setCapacities([]);

                      setForm((prev) => ({
                        ...prev,

                        customerId: selected?.value || "",

                        customerName: selected?.label || "",

                        addressId: "",

                        addressLine1: "",

                        makeId: "",

                        makeName: "",

                        modelId: "",

                        modelName: "",

                        modelCapacityId: null,

                        modelCapacity: null,
                      }));
                    }}
                  />
                )}
              </div>

              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-medium">Address</label>

                  <button
                    type="button"
                    onClick={() => {
                      setManualAddress(!manualAddress);

                      setSelectedAddress(null);

                      setAddressInput("");

                      setForm((prev) => ({
                        ...prev,

                        addressId: "",

                        addressLine1: "",

                        address: [],
                      }));
                    }}
                    className="text-xs text-blue-600 hover:underline"
                  >
                    {manualAddress ? "Select Existing" : "Add New"}
                  </button>
                </div>

                {manualAddress ? (
                  <div className="space-y-3">
                    <div className="flex gap-3">
                      <input
                        value={addressInput}
                        onChange={(e) => setAddressInput(e.target.value)}
                        placeholder="Enter Address"
                        className="flex-1 border border-slate-300 rounded-xl px-4 py-3"
                      />

                      <button
                        type="button"
                        className="bg-primary text-white px-4 py-3 rounded-xl"
                        onClick={() => {
                          if (!addressInput.trim()) return;

                          setForm((prev) => ({
                            ...prev,

                            address: [
                              ...(prev.address || []),

                              addressInput.trim(),
                            ],
                          }));

                          setAddressInput("");
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="flex flex-wrap gap-2">
                      {form.address?.map((item: string, index: number) => (
                        <div
                          key={index}
                          className="bg-blue-50 text-blue-700 px-3 py-2 rounded-xl flex items-center gap-2"
                        >
                          <span>{item}</span>

                          <button
                            type="button"
                            className="text-red-500 font-bold"
                            onClick={() => {
                              setForm((prev) => ({
                                ...prev,

                                address: prev.address.filter(
                                  (_: string, i: number) => i !== index,
                                ),
                              }));
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <AsyncPaginate
                    key={`${form.customerId}-${selectedCustomer?.value}`}
                    value={selectedAddress}
                    isDisabled={!form.customerId}
                    additional={{
                      page: 1,
                    }}
                    placeholder="Search Address"
                    loadOptions={(search, _loaded, additional) =>
                      loadAddressOptions(form.customerId, search, additional)
                    }
                    onChange={(selected: any) => {
                      setSelectedAddress(selected);

                      const fullAddress = `${selected?.data?.addressLine1 || ""}
          ${selected?.data?.addressLine2 || ""}
          ${selected?.data?.city || ""}
          ${selected?.data?.state || ""}
          ${selected?.data?.postalCode || ""}`
                        .replace(/\s+/g, " ")
                        .trim();

                      setForm((prev) => ({
                        ...prev,

                        addressId: selected?.value || "",

                        addressLine1: selected?.data?.addressLine1 || "",

                        address: [fullAddress],
                      }));
                    }}
                  />
                )}

                {!manualAddress && form.address?.length > 0 && (
                  <div className="mt-2 text-xs text-slate-500 bg-slate-50 border rounded-lg p-2">
                    {form.address[0]}
                  </div>
                )}
              </div>
              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-medium">Make</label>

                  <button
                    type="button"
                    onClick={() => {
                      setManualMake(!manualMake);

                      setSelectedMake(null);

                      setSelectedModel(null);

                      setSelectedCapacity(null);

                      setModels([]);

                      setCapacities([]);

                      setForm((prev) => ({
                        ...prev,

                        makeId: "",
                        makeName: "",
                        make: "",

                        modelId: "",
                        modelName: "",

                        modelCapacityId: null,
                        modelCapacity: null,
                      }));
                    }}
                    className="text-xs text-blue-600 hover:underline"
                  >
                    {manualMake ? "Select Existing" : "Add New"}
                  </button>
                </div>

                {manualMake ? (
                  <input
                    value={form.make}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,

                        make: e.target.value,
                      }))
                    }
                    placeholder="Enter Make"
                    className="w-full border border-slate-300 rounded-xl px-4 py-3"
                  />
                ) : (
                  <AsyncPaginate
                    value={selectedMake}
                    loadOptions={loadMakeOptions}
                    additional={{
                      page: 1,
                    }}
                    placeholder="Search Make"
                    onChange={async (selected: any) => {
                      setSelectedMake(selected);

                      // RESET MODEL + CAPACITY

                      setSelectedModel(null);

                      setSelectedCapacity(null);

                      setModels([]);

                      setCapacities([]);

                      const makeId = selected?.value;

                      setForm((prev) => ({
                        ...prev,

                        makeId: makeId || "",

                        makeName: selected?.label || "",

                        make: "",

                        modelId: "",

                        modelName: "",

                        modelCapacityId: null,

                        modelCapacity: null,
                      }));

                      if (!makeId) return;

                      const result = await getModelsByMake(makeId);

                      setModels(result || []);
                    }}
                  />
                )}
                {/* 
                {!manualMake && form.makeName && (
                  <div className="mt-2 text-xs text-slate-500 bg-slate-50 border rounded-lg p-2">
                    Selected Make:{" "}
                    <span className="font-medium">{form.makeName}</span>
                  </div>
                )} */}
              </div>

              {/* MODEL */}

              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-medium">Model</label>

                  <button
                    type="button"
                    onClick={() => {
                      setManualModel(!manualModel);

                      setSelectedModel(null);

                      setSelectedCapacity(null);

                      setCapacities([]);

                      setForm((prev) => ({
                        ...prev,

                        modelId: "",
                        modelName: "",
                        model: "",

                        modelCapacityId: null,
                        modelCapacity: null,
                      }));
                    }}
                    className="text-xs text-blue-600 hover:underline"
                  >
                    {manualModel ? "Select Existing" : "Add New"}
                  </button>
                </div>

                {manualModel ? (
                  <input
                    value={form.model}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,

                        model: e.target.value,
                      }))
                    }
                    placeholder="Enter Model"
                    className="w-full border border-slate-300 rounded-xl px-4 py-3"
                  />
                ) : (
                  <Select
                    key={form.makeId}
                    value={selectedModel}
                    placeholder="Search Model"
                    options={models.map((x: any) => ({
                      value: x.id,

                      label: x.name,

                      data: x,
                    }))}
                    onChange={async (selected: any) => {
                      setSelectedModel(selected);

                      // RESET CAPACITY

                      setSelectedCapacity(null);

                      setCapacities([]);

                      const modelId = selected?.value;

                      setForm((prev) => ({
                        ...prev,

                        modelId: modelId || "",

                        modelName: selected?.label || "",

                        model: "",

                        modelCapacityId: null,

                        modelCapacity: null,
                      }));

                      if (!modelId) return;

                      const result = await getCapacitiesByModel(modelId);

                      setCapacities(result || []);
                    }}
                  />
                )}
                {/* 
                {!manualModel && form.modelName && (
                  <div className="mt-2 text-xs text-slate-500 bg-slate-50 border rounded-lg p-2">
                    Selected Model:{" "}
                    <span className="font-medium">{form.modelName}</span>
                  </div>
                )} */}
              </div>

              {/* CAPACITY */}

              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-medium">Capacity</label>

                  <button
                    type="button"
                    onClick={() => {
                      setManualCapacity(!manualCapacity);

                      setSelectedCapacity(null);

                      setForm((prev) => ({
                        ...prev,

                        modelCapacityId: null,

                        modelCapacity: null,

                        capacity: [],
                      }));
                    }}
                    className="text-xs text-blue-600 hover:underline"
                  >
                    {manualCapacity ? "Select Existing" : "Add New"}
                  </button>
                </div>

                {manualCapacity ? (
                  <div className="space-y-3">
                    <div className="grid grid-cols-5 gap-3">
                      <input
                        type="number"
                        step="0.001"
                        placeholder="Division"
                        value={divisionValue}
                        onChange={(e) => setDivisionValue(e.target.value)}
                        className="border border-slate-300 rounded-xl px-4 py-3"
                      />

                      <select
                        value={divisionUnit}
                        onChange={(e) => setDivisionUnit(e.target.value)}
                        className="border border-slate-300 rounded-xl px-4 py-3"
                      >
                        <option value="mg">mg</option>
                        <option value="g">g</option>
                        <option value="kg">kg</option>
                        <option value="t">t</option>

                        <option value="lb">lb</option>

                        <option value="oz">oz</option>
                      </select>

                      <input
                        type="number"
                        step="0.001"
                        placeholder="Capacity"
                        value={capacityValue}
                        onChange={(e) => setCapacityValue(e.target.value)}
                        className="border border-slate-300 rounded-xl px-4 py-3"
                      />

                      <select
                        value={capacityUnit}
                        onChange={(e) => setCapacityUnit(e.target.value)}
                        className="border border-slate-300 rounded-xl px-4 py-3"
                      >
                        <option value="mg">mg</option>
                        <option value="g">g</option>
                        <option value="kg">kg</option>
                        <option value="t">t</option>

                        <option value="lb">lb</option>

                        <option value="oz">oz</option>
                      </select>

                      <button
                        type="button"
                        className="bg-primary text-white rounded-xl px-4 py-3"
                        onClick={() => {
                          if (!divisionValue || !capacityValue) return;

                          const item = `${divisionValue} ${divisionUnit} × ${capacityValue} ${capacityUnit}`;

                          setForm((prev) => ({
                            ...prev,

                            capacity: [...(prev.capacity || []), item],
                          }));

                          setDivisionValue("");

                          setCapacityValue("");

                          setDivisionUnit("kg");

                          setCapacityUnit("kg");
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="flex flex-wrap gap-2">
                      {form.capacity?.map((item: string, index: number) => (
                        <div
                          key={index}
                          className="bg-blue-50 text-blue-700 px-3 py-2 rounded-xl flex items-center gap-2"
                        >
                          <span>{item}</span>

                          <button
                            type="button"
                            className="text-red-500 font-bold"
                            onClick={() => {
                              setForm((prev) => ({
                                ...prev,

                                capacity: prev.capacity.filter(
                                  (_: string, i: number) => i !== index,
                                ),
                              }));
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <Select
                    key={form.modelId}
                    value={selectedCapacity}
                    placeholder="Search Capacity"
                    options={capacities.map((x: any) => ({
                      value: x.id,

                      label: `${x.division}${x.divisionUnitName} × ${x.capacity}${x.capacityUnitName}`,

                      data: x,
                    }))}
                    onChange={(selected: any) => {
                      setSelectedCapacity(selected);

                      setForm((prev) => ({
                        ...prev,

                        modelCapacityId: selected?.value,

                        modelCapacity: selected?.data,

                        capacity: [],
                      }));
                    }}
                  />
                )}
              </div>

              {/* SERIAL */}

              <div>
                <label className="block text-sm font-medium mb-2">
                  Serial Number
                </label>

                <input
                  value={form.serialNumber}
                  onChange={(e) =>
                    setForm({
                      ...form,

                      serialNumber: e.target.value,
                    })
                  }
                  className="w-full border border-slate-300 rounded-xl px-4 py-3"
                />
              </div>

              {/* IDENTIFIER */}

              <div>
                <label className="block text-sm font-medium mb-2">
                  Identifier
                </label>

                <input
                  value={form.identifier}
                  onChange={(e) =>
                    setForm({
                      ...form,

                      identifier: e.target.value,
                    })
                  }
                  className="w-full border border-slate-300 rounded-xl px-4 py-3"
                />
              </div>

              {/* NMI */}

              <div>
                <label className="block text-sm font-medium mb-2">
                  NMI Number
                </label>

                <input
                  value={form.nmiNumber}
                  onChange={(e) =>
                    setForm({
                      ...form,

                      nmiNumber: e.target.value,
                    })
                  }
                  className="w-full border border-slate-300 rounded-xl px-4 py-3"
                />
              </div>

              {/* LOCATION */}

              <div>
                <label className="block text-sm font-medium mb-2">
                  Location
                </label>

                <input
                  value={form.location}
                  onChange={(e) =>
                    setForm({
                      ...form,

                      location: e.target.value,
                    })
                  }
                  className="w-full border border-slate-300 rounded-xl px-4 py-3"
                />
              </div>
            </div>
          </div>

          {/* COMMENTS */}

          <div className="bg-white border border-slate-200 rounded-3xl p-6">
            <h2 className="text-xl font-bold mb-5">Additional Information</h2>

            <div className="space-y-5">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Comment
                </label>

                <textarea
                  rows={4}
                  value={form.comment}
                  onChange={(e) =>
                    setForm({
                      ...form,

                      comment: e.target.value,
                    })
                  }
                  className="w-full border border-slate-300 rounded-xl px-4 py-3"
                />
              </div>

              <div>
                <label className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    checked={form.isReserved}
                    onChange={(e) =>
                      setForm({
                        ...form,

                        isReserved: e.target.checked,
                      })
                    }
                  />

                  <span>Reserved Scale</span>
                </label>
              </div>
            </div>
          </div>

          {/* BUTTONS */}

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={() => navigate("/scales")}
              className="px-6 py-3 border rounded-2xl"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="bg-primary text-white px-8 py-3 rounded-2xl font-semibold"
            >
              Update Scale
            </button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default EditScale;
